import React from 'react';
import TeamsFilterDropdown from '../../../../../../shared/components/teams-filter';

type IProps = {
  usersIds: number[];
  onUserIdsChange: (userIds: number[]) => void;
};
const TeamsFilter: React.FC<IProps> = ({ usersIds, onUserIdsChange }) => (
  <TeamsFilterDropdown
    defaultSelectedUsers={usersIds}
    onUserIdsChange={onUserIdsChange}
  />
);

export default TeamsFilter;
